import {Draggable} from "react-beautiful-dnd";
import React from "react";
import {Keying2Config} from "../../../../api/Keying2";

export function KeyingColumnSorting(props: {
    labelsAvailable: Keying2Config["labelsAvailable"];
    onShowEditDesignation(name: string): void;
}) {

    return (
        <>
            {props.labelsAvailable?.map((l, index) =>
                <Draggable draggableId={l.name} index={index} key={l.name}>
                    {(provided: any, snapshot: any) => (
                        <div
                            key={l.name}
                            ref={provided.innerRef}
                            {...provided.dragHandleProps}
                            {...provided.draggableProps}
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                flexWrap: "nowrap",
                                cursor: "pointer",
                                background: "none",
                                border: "none",
                                textAlign: "left",
                                fontWeight: "500",
                                width: 100,
                                ...provided.draggableProps.style,
                            }}
                            onContextMenu={(e) => {
                                e.preventDefault()
                                props.onShowEditDesignation(l.name);
                            }}
                        >
                            <div style={{
                                whiteSpace: "wrap",
                                wordBreak: "break-word",
                                flex: 1,
                                textAlign: "center"
                            }}>
                                <div>{l.name}</div>
                                <div>{l.title}</div>
                            </div>
                        </div>
                    )}
                </Draggable>
            )}
        </>
    )
}